;(function($, undefined){
    "use strict";

    var rnn = window.rnn, log, maps, forms, Form, Field;

    function fireAddressChanged($target, address){
        var addressChangedEvent = $.Event('addresschanged');

        addressChangedEvent.address = address;

        addressChangedEvent.target = $target[0];

        $target.trigger(addressChangedEvent);
    }

    function addressFieldChanged(event){
        var $target = $(event.target),
            $form = $target.closest('.mapArea'),
            $streetAddress = $form.find('[name=street_address]'),
            $locality = $form.find('[name=locality]'),
            streetAddress = $locality.val();

        $target.closest('.control-group').removeClass("error");

        if ($streetAddress.val()) {
            streetAddress = $streetAddress.val() + ', ' + streetAddress;
        }

        fireAddressChanged($target, streetAddress);
    }

    function addressChanged(event) {
        var address = event.address,
            location = event.location,
            $target = $(event.target),
            $form = $target.closest('.mapArea'),
            $streetAddress = $form.find('[name=street_address]'),
            $locality = $form.find('[name=locality]'),
            $localityId = $form.find('[name=locality_id]'),
            streetAddress = '',
            localityText = '';

        if (event.target === $streetAddress[0] || event.target === $locality[0]) {
            // We dont want to listen to our own events!
            return;
        }

        if(!address){
            $streetAddress.val(null);
            $locality.val(null);
            return;
        }

        if (address.postCode) {
            if (address.locality) {
                if (address.postCode.indexOf(address.locality) === 0) {
                    localityText = address.postCode;
                } else {
                    localityText = address.locality + ', ' + address.postCode;
                }
            } else {
                localityText = address.postCode;
            }
        } else if (address.locality) {
            localityText = address.locality;
        }
        if (address.streetAddress) {
            streetAddress = address.streetAddress;
        }

        if (localityText || streetAddress) {

            $streetAddress.val(streetAddress);

            // When the locality text changes, clear the hidden Locality ID.
            // We can't easily determine the new value, so just lose it.
            if (localityText != $locality.val()) {
                $localityId.val('');
                $locality.val(localityText);
            }
        }
    }

    function locationChanged(event) {
        var $target = $(event.target),
            $form = $target.closest('.mapArea'),
            $latitude = $form.find('[name=latitude]'),
            $longitude = $form.find('[name=longitude]'),
            position = event.location;

        $latitude.val(position.latitude);
        $longitude.val(position.longitude);
    }

    function handleNoGeocodeResults(event) {
        $(event.target).closest(".control-group").addClass("error");
    }

    function validateTermsAndConditions($checkbox, data){
        var agreedToTheTerms = $checkbox.is(":checked");

        if(!agreedToTheTerms)
        {
            data.valid = false;
            data.errors["terms"] = ["This field is required."];
        }

        return data;
    }

    function initForms(){

        function NoticeForm(options){
            this.base.apply(this, arguments);
        }

        NoticeForm.prototype = Object.create(Form.prototype);
        NoticeForm.prototype.type = "notice";
        NoticeForm.prototype.constructor = NoticeForm;
        NoticeForm.prototype.action = rnn.site.notice.postURL;
        NoticeForm.prototype.noticeTypes = rnn.site.notice.types;
        NoticeForm.prototype.validateReturn = function(data, success, error){
            var $termsAndConditionsChecbox = $(this.fields.terms.element).find(":input");
            data = validateTermsAndConditions($termsAndConditionsChecbox, $.parseJSON(data));
            if(!data){
                error({});
            }
            data.valid ? success(data) : error(data);
        };
        NoticeForm.prototype.create = function(){
            var form = this.base.prototype.create.apply(this, arguments),
                map = this.map = $.el.div({'class':'map'}),
                leftColumn = $($.el.div({'class':'leftColumn'})),
                rightColumn = $($.el.div({'class':'rightColumn'})),
                clearAddressButton,
                recaptcha = $($.el.div({
                    'class':'g-recaptcha',
                    'data-sitekey': rnn.site.recaptchaKey,
                    'data-callback': 'onRecaptchaSolved',
                    'data-size': 'invisible'
                }));

            // Register fields with the form
            form.registerField({name: 'title', placeholder: 'Title', title: 'Title'});

            form.registerField({name: 'type', placeholder: 'Choose a category', title: 'Type', element: 'select' });

            form.registerField({name: 'description', element: 'textarea', placeholder: 'Your Notice...', title: 'Description'});
            form.registerField({name: 'street_address', placeholder: 'Address', title: 'Address'});
            form.registerField({name: 'locality', placeholder: 'Suburb, Town, Postcode', title: 'Locality'});

            form.registerField({name: 'terms', title: 'Terms and conditions', type:'checkbox', label:
                'I certify that I have the right to distribute these photos and I agree with the ',
                append: $.el.a({href:rnn.site.termsUrl, 'class':'show_full_tc'}, 'Terms and Conditions.')
            });
            form.registerField(new rnn.modules.tags.TagsSelector({url: rnn.site.tagsURL, name:'tags', placeholder:'Add a tag', title: 'Tags', multiSelect: true, element: 'select'}));
            var imageField = rnn.modules.imageUpload.addImageFieldsTo(form, {name: 'image', title: 'Image Upload'}, {name: 'caption', title: 'Image Caption'});

            // Hidden Fields
            form.registerField({name: 'latitude', type: 'hidden'}, true);
            form.registerField({name: 'longitude', type: 'hidden'}, true);
            form.registerField({name: 'locality_id', type: 'hidden'}, true);

            var typeInput = $(form.fields.type.element).find('select'),
                localityControlGroup = $(form.fields.locality.element);

            localityControlGroup.data('typeahead-ajax', {
                url: rnn.site.typeaheadURL,
                params: {'types': 'po', 'return': 'id', 'format': 'sensible'},
                target: 'input[name=locality_id]',
                input: localityControlGroup.find('input')
            });

            rnn.modules.forms.lazyTypeAhead(localityControlGroup);

            if(form.noticeTypes['']){
                typeInput.append($.el.option({value: ''}, form.noticeTypes['']));
            }

            for(var key in form.noticeTypes){
                var option = $.el.option({value: key}, form.noticeTypes[key]);
                typeInput.append(option);
            }

            leftColumn.append(
                form.fields.title.element,
                form.fields.type.element,
                form.fields.description.element,
                form.fields.tags.element,
                imageField
            );

            rightColumn.append(
                map,
                form.fields.street_address.element,
                form.fields.locality.element,
                form.fields.terms.element
            );

            // Add events, and append elements to the forms element
            $(form.element)
                .addClass('noticeForm mapArea')
                .on('change', '[name=locality]', addressFieldChanged)
                .on('keyup keypress', '[name=street_address],[name=locality]', _.debounce(addressFieldChanged, 300))
                .on('addresschanged', addressChanged)
                .on('locationchanged', locationChanged)
                .on('noresults', handleNoGeocodeResults)
                .on('addresschanged', function(event){
                    var clearButton = $(form.element).find('.clearAddress');
                    if(!event.address){
                        clearButton.remove();
                        return;
                    }
                    if(!clearButton.length){
                        $(form.fields.locality.element).after(clearButton = $($.el.button({'type':'button', 'class':'clearAddress btn'}, "Clear Address")));

                        clearButton.on('click', function(){
                            $(form.element).trigger('addresschanged');
                            clearButton.remove();
                        });
                    }
                })
                .append(
                    $.el.p(form.intro),
                    leftColumn,
                    rightColumn, 
                    recaptcha
                );

            $(map).data('mapMarker', rnn.site.defaultLocation);
            rnn.modules.maps.createLocationPickerMap(map);

            return this;
        };

        // Expose the constructor on the module.
        rnn.modules.ugc2.NoticeForm = NoticeForm;
    }

    // Initialise Notices
    function initUgcNotices() {
        log = rnn.logging.log;
        maps = rnn.modules.maps;
        forms = rnn.modules.forms;
        Form = forms.Form;
        Field = forms.Field;

        initForms();
    }

    rnn.modules.register('ugcNotices', {
        init: initUgcNotices
    });

}(jQuery));
